// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3feAN","header":"Messages_header__1eIkG"};